import { isProductionMarleyInstance } from '@app/utils/environment';

export const EXPECTED_RESPONSE_TIME = 24 * 60 * 60;
export const DEADLINE_GREEN_SECS = 3 * 60 * 60;
export const DEADLINE_RED_SECS = 1 * 60 * 60;

export const FILTER_DEBOUNCE = 500;

export const GOOGLE_PLACES_API_KEY = process.env.GOOGLE_PLACES_API_KEY || '';

// Browser tab title, resolved per environment at build time by
// config/app-environment.js: `Marley Chat` in prod, `<Env>: Marley Chat`
// everywhere else. Anything that retitles the tab at runtime must build on this
// rather than hardcoding the name, or it drops the environment prefix. The
// fallback covers Jest, where DefinePlugin never runs.
export const APP_TITLE = process.env.APP_TITLE || 'Marley Chat';

// The e2e test extension's fixed id, pinned via the CONNECT_EXTENSION_KEY repo
// secret. Trusted only in non-prod so the post-merge browser-extension e2e can
// drive the real Okta login against deployed dev/staging without being a prod
// trust surface.
export const E2E_EXTENSION_ID = 'cfmbeleemgicjlggjbddlmckdfllmfch';

const trustedExtensionIds = [
  process.env.CONNECT_EXTENSION_ID || E2E_EXTENSION_ID,
  // Routed through the canonical prod check so UAT (prod flag set but a uat
  // account) is treated as non-prod and still trusts the e2e id.
  ...(isProductionMarleyInstance() ? [] : [E2E_EXTENSION_ID]),
];

export const TRUSTED_EXTENSION_ORIGINS = [...new Set(trustedExtensionIds)]
  .filter(Boolean)
  .map((id) => `chrome-extension://${id}`);

// Back-compat: existing callers import EXTENSION_ORIGIN as a single value.
export const [EXTENSION_ORIGIN] = TRUSTED_EXTENSION_ORIGINS;

export const isTrustedExtensionOrigin = (origin) =>
  TRUSTED_EXTENSION_ORIGINS.includes(origin);
